import { trackEvent } from '@zep/logger/tracking';

import { type AiGenerationCompletedPlace } from './events.quiz-ai-builder';

/**
 * 「AI 생성 완료」 브리지 — 채팅 턴과 생성기 실행이 함께 쓴다.
 *
 * 스트림 중간이 아니라 끝난 뒤 generation 별 1회 남긴다. 문항이 draft 에 들어간 generation 은
 * 턴·실행이 중단·오류로 끝나도 완료로 센다(이미 적용이 일어났으므로).
 */
export type AppliedGenerationCounter = {
  /** draft 에 적용된 문항 수를 그 generation 에 더한다. generation id 가 없으면 세지 않는다. */
  add: (generationId: string | undefined, quizCount: number) => void;
  /** 모은 generation 마다 생성 완료를 1회 남긴다. */
  track: (context: {
    place: AiGenerationCompletedPlace;
    promptType: 'source' | 'query';
    sessionId: string;
    clientRequestId: string;
  }) => void;
};

export const createAppliedGenerationCounter = (): AppliedGenerationCounter => {
  const quizCounts = new Map<string, number>();

  return {
    add: (generationId: string | undefined, quizCount: number) => {
      if (!generationId) return;
      quizCounts.set(
        generationId,
        (quizCounts.get(generationId) ?? 0) + quizCount,
      );
    },
    track: ({ place, promptType, sessionId, clientRequestId }) => {
      for (const [generationId, quizCount] of quizCounts) {
        trackEvent('biz_ai_generation_completed', {
          place,
          generation_id: generationId,
          prompt_type: promptType,
          quizCount,
          ai_builder_session_id: sessionId,
          client_request_id: clientRequestId,
        });
      }
    },
  };
};
